module.exports = __webpack_public_path__ + "img/img_helper_empty.b65182d6.svg";